export default "__VITE_ASSET__OtZAK8Ew__"